import * as types from './actionTypes';

export const setkioskIdAndGetTokensDataRequest = (kioskIdentifier, action) => {
    if (action)
        return {
            type: types.SET_KIOSK_ID_AND_GET_MENUS_DATA_REQUEST,
            payload: { kioskIdentifier, action },
            loadingType: types.SET_LOADING,
            loadPayload: true
        }
    else
        return {
            type: types.SET_KIOSK_ID_AND_GET_MENUS_DATA_REQUEST,
            payload: { kioskIdentifier, action }
        }
};
export const setKioskIdAndGetMenusDataResponse = (kioskId, themeName, menusTData, action, errorMessag, isLicenseActive = null, kioskStartTime, kioskEndTime, kioskIdentifier, kioskType, isFeedback, locationId, isEnabledDobAuth, kioskStatus) => {
    if (action)
        return {
            type: types.SET_KIOSK_ID_AND_GET_MENUS_DATA_RESPONSE,
            payload: { kioskId, themeName, menusTData, errorMessag, isLicenseActive, kioskStartTime, kioskEndTime, kioskIdentifier, kioskType, isFeedback, locationId, isEnabledDobAuth, kioskStatus },
            loadingType: types.SET_LOADING,
            loadPayload: false
        }
    else
        return {
            type: types.SET_KIOSK_ID_AND_GET_MENUS_DATA_RESPONSE,
            payload: { kioskId, themeName, menusTData, isLicenseActive, kioskStartTime, kioskEndTime, kioskIdentifier, kioskType, isFeedback, locationId, isEnabledDobAuth, kioskStatus }
        }
};
export const setLanguageRequest = (lang) => ({
    type: types.SET_LANGUAGE_REQUEST,
    loadingType: types.SET_LOADING,
    loadPayload: true,
    payload: lang
})
export const setLanguageResponse = (language) => ({
    type: types.SET_LANGUAGE_RESPONSE,
    loadingType: types.SET_LOADING,
    loadPayload: false,
    payload: { language }
})
export const menuSelectionRequest = (selectedMenu) => ({
    type: types.SET_KIOSK_MENU_SELECTION_REQUEST,
    payload: selectedMenu,
    loadPayload: true,
    loadingType: types.SET_LOADING,
})

export const menuSelectionResponce = (selectedMenu, selectedArea, menuId, errorMessage) => ({
    type: types.SET_KIOSK_MENU_SELECTION_RESPONCE,
    payload: { selectedMenu, selectedArea, menuId, errorMessage },
    loadPayload: false,
    loadingType: types.SET_LOADING,
})

export const selectedKioskMode = (mode, mrnNo, errorMessage) => ({
    type: types.SELECTED_KIOSK_MODE,
    payload: { mode, mrnNo, errorMessage },
    loadPayload: false,
    loadingType: types.SET_LOADING
});


export const suspendErrorMethod = (redirectingMenus) => ({
    type: types.SUSPEND_ERROR_METHOD,
    payload: redirectingMenus,
    loadPayload: false,
    loadingType: types.SET_LOADING,
})

export const exitAction = () => ({
    type: types.EXIT_ACTION,
    loadPayload: false,
    loadingType: types.SET_LOADING,
})

export const backActionRequest = () => ({
    type: types.BACK_ACTION_REQUEST,
    loadPayload: true,
    loadingType: types.SET_LOADING,
})

export const backActionResponse = (selectedArea, clearEmiratesData) => ({
    type: types.BACK_ACTION_RESPONSE,
    payload: { selectedArea, clearEmiratesData },
    loadPayload: false,
    loadingType: types.SET_LOADING,
});

export const mrnSubmitRequest = (mrnNumber, dob?) => ({
    type: types.MRN_SUBMIT_REQUEST,
    payload: { mrnNumber, dob },
    loadPayload: true,
    loadingType: types.SET_LOADING,
});


export const tokenTemplateAreaResponse = (tokenTemplate, templatesData, token, mrn, currentSelectedArea, errorMsg) => {
    return {
        type: types.TOKEN_TEMPLATE_AREA_RESPONSE,
        payload: { tokenTemplate, templatesData, token, mrn, currentSelectedArea, errorMsg },
        loadPayload: false,
        loadingType: types.SET_LOADING,
    }
}

export const appointmentsAreaResponse = (appointmentsData, currentSelectedArea, errorMsg) => {
    return {
        type: types.APPOINTMENTS_AREA_RESPONSE,
        payload: { appointmentsData, currentSelectedArea, errorMsg },
        loadPayload: false,
        loadingType: types.SET_LOADING,
    }
}
export const appointmentsCheckinRequest = (encounterId) => {
    return {
        type: types.APPOINTMENT_CHECKEIN_REQUEST,
        payload: encounterId,
        loadPayload: true,
        loadingType: types.SET_LOADING,
    }
}
export const appointmentsCheckinResponse = (selectedArea, tokenNo, mrnNo, tokenTemplate, templatesData, errorMsge) => {
    return {
        type: types.APPOINTMENT_CHECKEIN_RESPONSE,
        payload: { selectedArea, tokenNo, mrnNo, tokenTemplate, templatesData, errorMsge },
        loadPayload: false,
        loadingType: types.SET_LOADING,
    }
}

export const getCurrentDateTimeRequest = () => {
    return {
        type: types.GET_CURRENT_DATE_TIME_REQUEST
    }
}
export const getCurrentDateTimeResponse = (dataTime) => {
    return {
        type: types.GET_CURRENT_DATE_TIME_RESPONSE,
        payload: dataTime
    }
}

export const getFeedbackRequest = (feedback) => {
    return {
        type: types.GET_FEEDBACK_REQUEST,
        payload: feedback,
        loadPayload: true,
        loadingType: types.SET_LOADING,
    }
}
export const getFeedbackResponse = (errorMsg) => {
    return {
        type: types.GET_FEEDBACK_RESPONSE,
        payload: errorMsg,
        loadPayload: false,
        loadingType: types.SET_LOADING,
    }
}


export const getEmiratesIdRequest = () => {
    return {
        type: types.GET_EMIRATES_ID_REQUEST,
        loadPayload: true,
        loadingType: types.SET_LOADING,
    }
}
export const getEmiratesIdResponse = (data, mrnNo, errorMessage) => {
    if (!errorMessage)
        return {
            type: types.GET_EMIRATES_ID_RESPONSE,
            payload: { data, mrnNo, errorMessage }
        }
    else
        return {
            type: types.GET_EMIRATES_ID_RESPONSE,
            payload: { data, mrnNo, errorMessage },
            loadPayload: false,
            loadingType: types.SET_LOADING
        }
}

export const idleErrorMessage = (msg) => ({
    type: types.IDLE_ERROR_MESSAGE,
    payload: msg
})

export const getPaymentDetailsRequest = (selectedMenu) => ({
    type: types.GET_PAYMENT_DETAILS_REQUEST,
    payload: selectedMenu,
    loadPayload: true,
    loadingType: types.SET_LOADING,
})

export const getPaymentDetailsResponse = (selectedArea, errorMessage) => ({
    type: types.GET_PAYMENT_DETAILS_RESPONSE,
    payload: { selectedArea, errorMessage },
    loadPayload: false,
    loadingType: types.SET_LOADING,
})

export const getAllDepartmentsAndServicesRequest = () => ({
    type: types.GET_DEPARTMENTS_REQUEST,
    loadPayload: true,
    loadingType: types.SET_LOADING,
})

export const getAllDepartmentsAndServicesResponse = (departments, errorMessage) => ({
    type: types.GET_DEPARTMENTS_RESPONSE,
    payload: { departments, errorMessage },
    loadPayload: false,
    loadingType: types.SET_LOADING,
})

export const getAllDoctorsRequest = (serviceId) => ({
    type: types.GET_DOCTORS_REQUEST,
    payload: serviceId,
    loadPayload: true,
    loadingType: types.SET_LOADING,
})

export const getAllDoctorsResponse = (doctorsList, serviceCode, timeSchdulesData, errorMessage) => ({
    type: types.GET_DOCTORS_RESPONSE,
    payload: { doctorsList, serviceCode, timeSchdulesData, errorMessage },
    loadPayload: false,
    loadingType: types.SET_LOADING,
})

export const setPaymentMode = (paymentType) => ({
    type: types.GET_PAYMENT_MODE,
    payload: paymentType
})

export const searchAction = (keyvalue) => ({
    type: types.SEARCHKEY,
    payload: keyvalue
});
export const doctorSelection = (drId) => ({
    type: types.SELECTEEDOCTOR,
    payload: drId
});
export const scheduleTimeselection = (time) => ({
    type: types.SELECTEDTIME,
    payload: time
});

export const getWalkInAppointmentRequest = (requestbody) => ({
    type: types.WALKIN_APPOINTMENT_REQUEST,
    payload: requestbody,
    loadPayload: true,
    loadingType: types.SET_LOADING,
})

export const getWalkInAppointmentResponse = (status, errorMessage) => ({
    type: types.WALKIN_APPOINTMENT_RESPONSE,
    payload: { status, errorMessage },
    loadPayload: false,
    loadingType: types.SET_LOADING,
})

export const isDobAuthentication = (page, mobileNo) => ({
    type: types.IS_DOB_AUTHENTICATION_ACTION,
    payload: { page, mobileNo },
    loadPayload: false,
    loadingType: types.SET_LOADING,
});

export const inputVerifyRequestAction = (number) => ({
    type: types.VERIFY_INPUT_REQUEST,
    payload: number,
    loadPayload: true,
    loadingType: types.SET_LOADING
});

export const inputVerifyResponse = (errorMessage) => ({
    type: types.VERIFY_INPUT_RSPONSE,
    payload: errorMessage,
    loadPayload: false,
    loadingType: types.SET_LOADING
});

export const redirectPageAction = (selectedArea) => ({
    type: types.REDIRECT_PAGE,
    payload: selectedArea
});

export const printTokenRequest = (templatesData, tokenNO) => {
    return {
        type: types.PRINT_TOKEN_REQUEST,
        payload: { templatesData, tokenNO }
    }
}
export const printTokenResponse = (errorMessage) => {
    return {
        type: types.PRINT_TOKEN_RESPONSE,
        payload: errorMessage
    }
}

export const cancelAllPendingRequests = () => ({
    type: types.CANCEL_ALL_PENDING_REQUESTS,
    loadPayload: false,
    loadingType: types.SET_LOADING
});

export const firstpassPage = () => ({
    type: types.FIRSPASSWELCOMEPAGE,
    loadPayload: false,
    loadingType: types.SET_LOADING
});









export const kioskRefreshTimeUpdate = (data) => ({ type: types.KIOSK_REFRESH_TIME_UPDATE, payload: data })
export const setResetForKioskStartTimeAndEndTime = () => ({ type: types.SET_RESET_FOR_KIOSK_START_TIME_AND_END_TIME });